import './sass/main.scss';
import './js/searchEvent';
import './js/modal';
import './js/preloader';
import './js/buttonScrollUp';
